import { cn } from "@/lib/utils";

const BentoGrid = ({
  children,
  className
}) => {
  return (
    <div
      className={cn("grid w-full auto-rows-[22rem] grid-cols-3 gap-4", className)}>
      {children}
    </div>
  );
};

const BentoCard = ({
  name,
  className,
  background,
  Icon,
  description
}) => (
  <div
    key={name}
    className={cn(
      "group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-xl",
      // light styles
      "bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]",
      // dark styles
      "transform-gpu dark:bg-transparent dark:[border:1px_solid_rgba(255,255,255,.1)]",
      className
    )}>
    <div>{background}</div>
    <div
      className="pointer-events-none z-10 flex transform-gpu flex-col gap-1 p-6">
      <Icon
        className="h-12 w-12 origin-left transform-gpu text-white" />
      <h3 className="text-xl font-semibold text-white">
        {name}
      </h3>
      <p className="max-w-lg text-gray-300">{description}</p>
    </div>
  </div>
);

export { BentoCard, BentoGrid };
